import Button from 'components/Button'
import Drawer from 'components/Drawer'
import Flex from 'components/Flex'
import DownLoadIcon from 'components/icons/DownLoad'
import UploadIcon from 'components/icons/Upload'
import DownLoadCandidate from 'modules/Exp-Candidates/DownloadAndUpload/DownloadCandidateDrawer/index'
import UploadResult from 'modules/Exp-Candidates/DownloadAndUpload/UploadResultDrawer/index'
import UploadInviteDrawer from 'modules/Exp-Candidates/DownloadAndUpload/UploadInviteDrawer/index'
import {
  IconWrapper,
  SubTextWrapper,
  TextWrapper,
  Wrapper,
} from 'modules/Exp-Candidates/DownloadAndUpload/style'
import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  downloadCandidate,
  downloadCandidateList,
  getRoleMetrics,
  uploadResultAPI,
} from '../../Exp-Candidates/actions'

const DownlaodUpload = ({
  driveId,
  noNeedRole,
  roleId,
  getCandidateList,
  getGDList,
  driveData,
  stage,
  fileUpload,
  type,
  checkType,
  candidateDeatils,
  assessment,
  rolesMetrics,
  setSearchParams,
  searchParams,
}) => {
  const dispatch = useDispatch()
  const driveRoleList = useSelector(state => state?.drives?.driveRolesMetrics)
  const roundList = useSelector(state => state?.drives?.roleMetrics)

  const [downloadCand, setDownloadCand] = useState(false)
  const [uploadResult, setUploadResult] = useState(false)
  const [isDrawer, setIsDrawer] = useState(false)

  const [selectedRoleId, setSelectedRoleId] = useState(driveRoleList[0]?.roleId)

  const [upload, setUpload] = useState(false)
  const [disable, setDisable] = useState(false)
  const [uploadInvite, setUploadInvite] = useState(false)

  const handleDownoload = () => {
    setIsDrawer(false)
    setDownloadCand(true)
  }

  const handleUpload = () => {
    setIsDrawer(false)
    setUploadResult(true)
    setUpload(false)
  }

  const handleUploadInvite = () => {
    setIsDrawer(false)
    setUploadInvite(true)
  }

  useEffect(() => {
    setSelectedRoleId(noNeedRole ? roleId : driveRoleList[0]?.roleId)
  }, [driveRoleList, noNeedRole, roleId])

  useEffect(() => {
    if (driveId && selectedRoleId) {
      dispatch(getRoleMetrics(driveId, selectedRoleId))
    }
  }, [driveId, selectedRoleId])

  useEffect(() => {
    setDisable(false)
    if (
      driveData?.driveMode === 'VIRTUAL_DRIVE' &&
      driveData?.corporateStatus === 'CANCELLED'
    ) {
      setDisable(true)
    }
  }, [driveData])
  const content = () => {
    return (
      <Fragment>
        <Wrapper
          onClick={handleDownoload}
          pointer={rolesMetrics?.count === 0}
          opacity={rolesMetrics?.count === 0}
        >
          <Flex>
            <IconWrapper>
              <DownLoadIcon />
            </IconWrapper>
          </Flex>
          <Flex column center>
            <TextWrapper>Download Candidate List</TextWrapper>
            <SubTextWrapper>
              Download Candidate List in Excel sheet
            </SubTextWrapper>
          </Flex>
        </Wrapper>
        <div style={{}}>
          <Wrapper
            onClick={handleUpload}
            pointer={rolesMetrics?.count === 0}
            opacity={rolesMetrics?.count === 0}
          >
            <Flex>
              <IconWrapper padding>
                <UploadIcon />
              </IconWrapper>
            </Flex>
            <Flex column center>
              <TextWrapper>Upload Result</TextWrapper>
              <SubTextWrapper>Upload result in Excel sheet</SubTextWrapper>
            </Flex>
          </Wrapper>
        </div>
        <div style={{}}>
          <Wrapper onClick={handleUploadInvite}>
            <Flex>
              <IconWrapper padding>
                <UploadIcon />
              </IconWrapper>
            </Flex>
            <Flex column center>
              <TextWrapper>Upload Students</TextWrapper>
              <SubTextWrapper>
                Use this option to upload Students to Invite for the Role to
                Apply
              </SubTextWrapper>
            </Flex>
          </Wrapper>
        </div>
      </Fragment>
    )
  }

  return (
    <>
      <Button.Secondary
        text={'Download / Upload'}
        height={'38px'}
        onClick={() => {
          setIsDrawer(true)
        }}
        disabled={disable}
      />

      <Drawer
        title={'Download / Upload'}
        placement="right"
        visible={isDrawer}
        content={content()}
        onClose={() => {
          setIsDrawer(false)
        }}
        closable
      />

      <DownLoadCandidate
        downloadCand={downloadCand}
        setDownloadcand={setDownloadCand}
        driveRoleList={driveRoleList}
        selectedRoleId={selectedRoleId}
        setSelectedRoleId={setSelectedRoleId}
        roundList={roundList}
        downloadCandidate={downloadCandidate}
        driveId={driveId}
        setIsDrawer={setIsDrawer}
        noNeedRole={noNeedRole}
        roleId={roleId}
        stage={stage}
      />

      <UploadResult
        type={type}
        checkType={checkType}
        uploadResult={uploadResult}
        setUploadResult={setUploadResult}
        driveRoleList={driveRoleList}
        selectedRoleId={selectedRoleId}
        setSelectedRoleId={setSelectedRoleId}
        roundList={roundList}
        noNeedRole={noNeedRole}
        downloadCandidateList={downloadCandidateList}
        driveId={driveId}
        roleId={roleId}
        uploadResultAPI={uploadResultAPI}
        setIsDrawer={setIsDrawer}
        getCandidateList={getCandidateList}
        getGDList={getGDList}
        getRoleMetrics={getRoleMetrics}
        upload={upload}
        setUpload={setUpload}
        stage={stage}
        fileUpload={fileUpload}
        assessment={assessment}
        rolesMetrics={rolesMetrics}
        setSearchParams={setSearchParams}
        searchParams={searchParams}
      />
      <UploadInviteDrawer
        visible={uploadInvite}
        setVisible={setUploadInvite}
        roleId={roleId}
        setIsDrawer={setIsDrawer}
      />
    </>
  )
}

export default DownlaodUpload
